export default class UserTableItem {
    userId = 0;
    orgCode = 0;
    orgCodeName = "";
    orgTypeId = 0;
    userDdOpenId = "";
    userWxMiniOpenId = "";
    userWxMpOpenId = "";
    userWxUnionId = "";
    deptId = 0;
    deptIdName = "";
    postId = 0;
    postIdName = "";
    userStatus = 0;
    userCode = "";
    userCodeZdd = "";
    userName = "";
    userPass = "";
    userIcon = "";
    realName = "";
    userPhone = "";
    roleIdList = "";
    roleIdListName = "";
    createTime = "";
    createName = "";
    modifyTime = "";
    modifyName = "";
}
